import {BREAK_POINTS} from './settings';
import addARIACurrent from './module/addARIACurrent';
import {fadeToggle} from './module/fade';
import {slideToggle} from './module/slide';
import scroll2AddClass from './module/scroll2AddClass';
import gnavToggle from './module/gnavToggle';

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
    addARIACurrent();
    slideToggle();
    scroll2AddClass();

		const put = this.document.getElementById('js-header-clone');
		const p = document.querySelector(".l-header");
		const clone = p.cloneNode(true);
		put.appendChild(clone)
		const put2 = this.document.querySelector('#js-header-clone .l-header__btn');
		const t = document.querySelector(".l-header__tel");
		const clone2 = t.cloneNode(true);
		put2.appendChild(clone2)

    const unitEl = document.querySelectorAll('.js-fade-unit');
    [].forEach.call(unitEl, function (el) {
      const btn = el.querySelector('.js-fade-switch')
      const elTarget = el.querySelector('.js-fade-target');
      btn.addEventListener('click', function(e) {
        fadeToggle(e.currentTarget, elTarget);
      })
    });

		const sunitEl = document.querySelectorAll('.js-slide-unit');

		[].forEach.call(sunitEl, function (el) {
			const sbtn = el.querySelector('.js-slide-switch')
			const sclose = el.querySelector('.js-slide-close')
			const selTarget = el.querySelector('.js-slide-target');
			if(sclose) {
				sclose.addEventListener('click', function(e) {
					el.classList.toggle('is');
					const icon = e.currentTarget.querySelector('.c-icon');
					if(icon) {
						icon.classList.toggle('is');
					}
					slideToggle(e.currentTarget, selTarget);
				});
			}
			sbtn.addEventListener('click', function(e) {
				el.classList.toggle('is');
				const icon = e.currentTarget.querySelector('.c-icon');
				if(icon) {
					icon.classList.toggle('is');
				}
				slideToggle(e.currentTarget, selTarget);
			});
		});
		const totopEl = document.getElementById('js-totop');
		window.addEventListener('scroll', function(e) {
			if(window.scrollY > 20) {
				totopEl.classList.add('is-show');
			} else {
				totopEl.classList.remove('is-show');
			}
			if(window.scrollY > 160) {
				put.classList.add('is-show');
			} else {
				put.classList.remove('is-show');
			}
		});

		if ( window.innerWidth < BREAK_POINTS.gtTAB) {
			const spunitEl = document.querySelectorAll('.js-sp-slide-unit');

			[].forEach.call(spunitEl, function (el) {
				const sbtn = el.querySelector('.js-sp-slide-switch')
				const selTarget = el.querySelector('.js-sp-slide-target');
				sbtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.currentTarget.querySelector('.c-icon').classList.toggle('is');
					slideToggle(el.currentTarget, selTarget);
				});
			});
		}

		window.onscroll = function() {scrollFunction()};

		function scrollFunction() {
			var elementScroll = document.body.scrollTop || document.documentElement.scrollTop;
			var windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
			var scrollPos = (elementScroll / windowHeight) * 100;
			document.getElementById("progBar").style.height = scrollPos + "%";
		}
  });


  gnavToggle();
})();
